import { useRef, useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './Videos.css';
import VideoSection from './VideoSection';

gsap.registerPlugin(ScrollTrigger);

const videos = [
  { id: "ewP9VfUaBvc", title: "Modern Office Transformation", client: "Roofings Group" },
  { id: "f-jdwKiJW_c", title: "Conference Tables", client: "USAID" },
  { id: "fRChVG36tPM", title: "Commercial Space Makeover", client: "Hisense Uganda" },
  { id: "8RHlIYDAIvE", title: "Office Tables  By Kajja Galleries", client: "Aponye" },
  // { id: "nO_RVMNbveU", title: "TV Unit By Kajja Galleries", client: "Private Residence" },
  // { id: "tdftwjs654Y", title: "Sauna and Lounge Benches", client: "Client in Lweza" }
];

const Videos = () => {
  const sectionRef = useRef();
  const videoRefs = useRef([]);

  useEffect(() => {
    gsap.from(sectionRef.current.querySelectorAll('.videos-card'), {
      y: 50,
      opacity: 0,
      duration: 1,
      stagger: 0.15,
      ease: "power3.out",
      scrollTrigger: {
        trigger: sectionRef.current,
        start: "top 80%"
      }
    });
  }, []);

  return (
    <section className="videos-section" ref={sectionRef}>
      <div className="videos-header">
        <h2>
          <span className="videos-maroon">Works </span> Done By Kajja Galleries
        </h2>
        <p className="videos-subtitle">Witness our craftsmanship come to life</p>
      </div>
      <div className="videos-gallery">
        {videos.map((video, index) => (
          <div 
            key={video.id}
            className="videos-card"
            ref={el => videoRefs.current[index] = el}
          >
            <div className="videos-wrapper">
              <iframe
                src={`https://www.youtube.com/embed/${video.id}?modestbranding=1&rel=0`}
                title={video.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                loading="lazy"
              ></iframe>
            </div>
            <div className="videos-info">
              <h3>{video.title}</h3>
              <p className="videos-client">{video.client}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Videos;
